(function ($) {
  Drupal.behaviors.siwertellHotspot = {
    attach: function (context) {
      // Search and replace 'hotspot' and replace with your name.
      // hotspot is a variable where we store everything.
      window.hotspot = {}

      // Init
      $('[data-load_screen]').on('click', function(e){
        var screen_id = $(this).data('load_screen');
        $('[data-screen_id="'+ screen_id +'"]').addClass('active').siblings().removeClass('active');
        $(this).blur();
        e.preventDefault();
      });

      // Reads what dot/text user hovers on (screen-start)
      $('.screen-start [data-load_screen]').hover(function () {
        var id = $(this).attr('data-load_screen');
        $('.screen-start [data-load_screen="'+ id +'"]').toggleClass('targeted-button');
      });

      // Display the thumbnail clicked
      $('.thumbnails [data-load_image]').click(function () {
        $('.active .image[data-load_image]').removeClass('display');
        var id = $(this).attr('data-load_image');
        $('.active .image[data-load_image="'+ id +'"]').addClass('display');
      });

    }
  }
})(jQuery);